import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { ApiConnectionListInitialState, ApiConnectionListLoad } from './api-connection-list.actions';
import { ApiConnectionListState, ApiConnectionListStateModel } from './api-connection-list.state';
import { ApiConnectionListSearchCriteria } from '../models';
import { ListSearchCriteriaFacade, ListSearchCriteriaType } from '../../../list-search-criteria';

@Injectable({ providedIn: 'root' })
export class ApiConnectionListFacade implements LoadDataFacade, SetInitialStateFacade {
  listDto$: Observable<ApiConnectionListStateModel> = this.store.select(ApiConnectionListState.getState);
  loaded$: Observable<boolean> = this.store.select(ApiConnectionListState.getLoaded);

  constructor(private store: Store, private listSearchCriteriaFacade: ListSearchCriteriaFacade) {}

  loadAll(): void {
    this.listSearchCriteriaFacade
      .getSearchCriteriaByListType(ListSearchCriteriaType.ApiConnections)
      .subscribe((searchCriteria: ApiConnectionListSearchCriteria) => {
        this.store.dispatch(new ApiConnectionListLoad(searchCriteria));
      });
  }

  setInitialState(): void {
    this.store.dispatch(new ApiConnectionListInitialState());
  }
}
